<template>
  <div
    ref="kt_modal_grupos_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_grupos_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen008.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Grupos</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalConsultarGrupo(false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-0">
          <ConsultarGrupo
            ref="ConsultarGrupo"
            :modal="this.modal"
            @adicionarGrupo="adicionarGrupo"
            @editarGrupo="editarGrupo"
            @exibirSubGrupo="exibirSubGrupo"
            @selecionarGrupo="selecionarGrupo"
          ></ConsultarGrupo>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="modalConsultarGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarGrupo"
    ref="kt_modal_grupos_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_grupos_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen055.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800" v-if="this.idGrupo === 0">
              Adicionar Grupo
            </h3>
            <h3 class="fw-bold m-0 text-gray-800" v-else>Editar Grupo</h3>
          </div>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarGrupo
            @cancelarGrupo="modalEditarGrupo"
            @confirmarGrupo="confirmarGrupo"
            :idGrupo="idGrupo"
          ></EditarGrupo>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirConsultarSubGrupo"
    ref="kt_modal_sub_grupo_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_sub_grupo_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/abstract/abs029.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">SubGrupo</h3>
          </div>
          <div
            v-if="this.modalSubGrupo === true"
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="modalConsultarSubGrupo(false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <div
            v-else
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalConsultarSubGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <ConsultarSubGrupo
            ref="ConsultarSubGrupo"
            :modal="this.modalSubGrupo"
            @adicionarSubGrupo="adicionarSubGrupo"
            @editarSubGrupo="editarSubGrupo"
            @selecionarSubGrupo="selecionarSubGrupo"
            :idGrupo="idGrupo"
          ></ConsultarSubGrupo>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="modalConsultarSubGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarSubGrupo"
    ref="kt_modal_sub_grupo_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_sub_grupo_editar"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen055.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800" v-if="this.idSubGrupo === 0">
              Adicionar SubGrupo
            </h3>
            <h3 class="fw-bold m-0 text-gray-800" v-else>Editar SubGrupo</h3>
          </div>
          <div
            class="btn btn-sm btn-light"
            data-bs-dismiss="modal"
            @click="modalEditarSubGrupo(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </div>
        </div>
        <div class="modal-body p-0">
          <EditarSubGrupo
            @cancelarSubGrupo="modalEditarSubGrupo"
            @confirmarSubGrupo="confirmarSubGrupo"
            :idGrupo="idGrupo"
            :idSubGrupo="idSubGrupo"
          ></EditarSubGrupo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarGrupo from "@/views/grupos/Consultar.vue";
import EditarGrupo from "@/views/grupos/Editar.vue";
import ConsultarSubGrupo from "../subgrupos/Consultar.vue";
import EditarSubGrupo from "../subgrupos/Editar.vue";
import {
  hideModal,
  showModal,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalGrupo", "selecionarGrupo", "selecionarSubGrupo"],
  props: {
    modal: { type: Boolean, required: false, default: false },
    modalSubGrupo: { type: Boolean, required: false, default: false },
  },
  components: {
    ConsultarGrupo,
    EditarGrupo,
    ConsultarSubGrupo,
    EditarSubGrupo,
  },
  methods: {
    //Emits ConsultarGrupo
    modalConsultarGrupo(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalGrupo", false);
      }
    },
    adicionarGrupo() {
      this.idGrupo = 0;
      this.modalEditarGrupo(true);
    },
    editarGrupo(id) {
      this.idGrupo = id;
      this.modalEditarGrupo(true);
    },
    selecionarGrupo(grupo) {
      this.$emit("selecionarGrupo", grupo);
      this.modalConsultarGrupo(false);
      hideModal(this.$refs.kt_modal_grupos_consultar);
    },
    //Emits EditarGrupo
    modalEditarGrupo(exibir) {
      this.exibirEditarGrupo = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_grupos_editar");
        }, 100);
      }
    },
    confirmarGrupo() {
      this.modalEditarGrupo(false);
      hideModal(this.$refs.kt_modal_grupos_editar);
      this.$refs.ConsultarGrupo.loadData();
    },
    exibirSubGrupo(id) {
      this.idGrupo = id;
      this.modalConsultarSubGrupo(true);
    },
    modalConsultarSubGrupo(exibir) {
      this.exibirConsultarSubGrupo = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_sub_grupo_consultar");
        }, 100);
      } else {
        if (this.modalSubGrupo === true) {
          this.modalConsultarGrupo(false);
        }
      }
    },
    adicionarSubGrupo() {
      this.idSubGrupo = 0;
      this.modalEditarSubGrupo(true);
    },
    editarSubGrupo(id) {
      this.idSubGrupo = id;
      this.modalEditarSubGrupo(true);
    },
    selecionarSubGrupo(subGrupo) {
      this.$emit("selecionarSubGrupo", subGrupo);
      this.modalConsultarSubGrupo(false);
      this.modalConsultarGrupo(false);
      hideModal(this.$refs.kt_modal_sub_grupo_consultar);
    },
    modalEditarSubGrupo(exibir) {
      this.exibirEditarSubGrupo = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_sub_grupo_editar");
        }, 100);
      }
    },
    confirmarSubGrupo() {
      this.modalEditarSubGrupo(false);
      hideModal(this.$refs.kt_modal_sub_grupo_editar);
      this.$refs.ConsultarSubGrupo.loadData();
    },
  },
  data() {
    return {
      idGrupo: 0,
      idSubGrupo: 0,
      exibirEditarGrupo: false,
      exibirConsultarSubGrupo: false,
      exibirEditarSubGrupo: false,
    };
  },
};
</script>

<style></style>
